import { Register, Form, Forgot, Reset } from "./index";

export default [
  {
    path: "/register",
    name: "register",
    component: Register
  },
  {
    path: "/register/form",
    name: "form",
    component: Form
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot
  },
  {
    path: "/reset",
    name: "reset",
    component: Reset
  },
  {
    path: "/auth/callback",
    component: () => import("./components/Redirect")
  }
];
